import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';

function Form() {
    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/modality-types/save`,
        endpointGetById: `${endpointBackend}gci/modality-types/getById`,
        urlGoBack: `/gci/modality-types/list`,
        pathView: `/gci/modality-types/view`
    }

    const labels = {
        labelTitleAdd: "Novo Tipo de Modalidade",
        labelTitleEdit: "Editar Tipo de Modalidade",
        labelTitleView: 'Visualizar Tipo de Modalidade'
    }

    const getForm = (values) => {

        let form = {
            fields: [
                {
                    name: 'acronym',
                    type: 'text',
                    label: 'Sigla Modalidade',
                    validations: {
                        required: true
                    },
                    columnSize: 6,
                },
                {
                    name: 'modality_type',
                    type: 'text',
                    label: 'Tipo de Modalidade',
                    validations: {
                        required: true
                    },
                    columnSize: 6,
                },
                {
                    name: 'description',
                    type: 'textarea',
                    label: 'Descrição',
                    validations: {
                        required: false
                    },
                    columnSize: 12,
                },
            ],
            ...paths,
            ...labels,
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
